<template>
  <div
    v-if="isVisible"
    class="flex justify-center bg-amber-400 text-white p-4 text-xl font-bold"
    :class="'top-alert-' + type"
  >
    <a :href="link" target="_blank">
      {{ text }}
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

const currentDate = new Date();

export default defineComponent({
  name: "UiAlert",
  props: {
    link: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "success",
    },
    text: {
      type: String,
      default: "",
    },
    expirationDate: {
      type: [Date, String],
      default: "",
    },
    startDate: {
      type: [Date, String],
      default: "",
    },
  },
  computed: {
    isVisible() {
      return (
        (!this.startDate || new Date(this.startDate) < currentDate) &&
        (!this.expirationDate || new Date(this.expirationDate) > currentDate)
      );
    },
  },
});
</script>

<style scoped>
.top-alert-success {
  background-color: #3b914d;
}

.top-alert-warning {
  background-color: #f6b100;
}

.top-alert-danger {
  background-color: #e44216;
}
</style>
